import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InvitationSanitized } from '../../interfaces/invitations/invitation';

@Component({
    selector: 'app-invitations-dialog',
    templateUrl: './invitations-dialog.component.html',
    styleUrls: ['./invitations-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvitationsDialogComponent {

    displayedColumns: string[] = [
        'added',
        'expiresAt',
        'isUsed'
    ];

    constructor(@Inject(MAT_DIALOG_DATA) public invitations: InvitationSanitized[]) {
    }

    ngOnInit(): void {
        if (this.invitations) {
            this.invitations = this.invitations.sort((a, b) => new Date(a.added).getTime() - new Date(b.added).getTime());
        } else {
            this.invitations = [];
        }
    }
}